module.exports = __webpack_public_path__ + "static/img/mobile.69990be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/mobile.png
// module id = HqLi
// module chunks = 7